import { State } from "appworks/state-machine/states/state";
import { PartnerConnectEndCommand } from "partner-connect/commands/partner-connect-end-command";

export class TGREnd extends State {

    public onEnter() {
        PartnerConnectEndCommand().then(() => {
            this.complete();
        });
    }
}
